<template>
  <div class="border border-1 rounded-3 p-3 mb-3 shadow-sm">
    <!-- 🔹 Título -->
    <div class="d-flex align-items-center mb-3">
      <i class="bi bi-funnel-fill fs-4 text-primary me-2"></i>
      <h4 class="fw-bold text-dark mb-0">FILTROS DE BÚSQUEDA:</h4>
    </div>

    <!-- 🔹 Campos de búsqueda -->
    <div class="row gy-3 gx-3">
      <!-- 🧍‍♂️ DOC IDENTIDAD -->
      <div class="col-lg-4 col-md-6 col-sm-12">
        <label class="tamaño d-flex align-items-center gap-2">
          <i class="bi bi-person-vcard text-danger fs-5"></i> DOC. IDENTIDAD:
        </label>
        <b-input
          :value="dni"
          @input="updateDni($event.target.value)"
          placeholder="BUSQ. POR DOC. IDENTIDAD"
          @keydown.space.prevent
        ></b-input>
      </div>

      <!-- 👤 APELLIDOS -->
      <div class="col-lg-4 col-md-6 col-sm-12">
        <label class="tamaño d-flex align-items-center gap-2">
          <i class="bi bi-person text-success fs-5"></i> APELLIDOS:
        </label>
        <b-input
          :value="apellidos"
          @input="updateApellidos($event.target.value)"
          placeholder="BUSQ. POR APELLIDOS"
          @keydown.space="apellidos.length === 0 && $event.preventDefault()"
        ></b-input>
      </div>

      <!-- 🏢 CLIENTE -->
      <div class="col-lg-4 col-md-6 col-sm-12">
        <label class="tamaño d-flex align-items-center gap-2">
          <i class="bi bi-diagram-3-fill text-info fs-5"></i> SUB SUBCENTRO:
        </label>
        <b-input
          :value="subSubCentro"
          @input="updateSubSubCentro($event.target.value)"
          placeholder="BUSQ. POR SUB SUBCENTRO"
          @keydown.space="subSubCentro.length === 0 && $event.preventDefault()"
        ></b-input>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SegCeseFilters',
  props: {
    dni: {
      type: String,
      default: ''
    },
    apellidos: {
      type: String,
      default: ''
    },
    subSubCentro: {
      type: String,
      default: ''
    }
  },
  methods: {
    updateDni(value) {
      this.$emit('update:dni', value.replace(/\s+/g, ''));
    },
    updateApellidos(value) {
      this.$emit('update:apellidos', value.replace(/^\s+/, ''));
    },
    updateSubSubCentro(value) {
      this.$emit('update:subSubCentro', value.replace(/^\s+/, ''));
    }
  }
};
</script>

<style scoped>
.tamaño {
  font-size: 0.65rem;
  font-weight: 800;
  color: #002c5d;
}
</style>